import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	warningLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	warningLabel: {
		id: 'native-issue-table.common.warning-indicator.warning-label',
		defaultMessage: 'Warning',
		description: 'Label for warning icon on a table header cell',
	},
});
export default messages;
